import { PiniaColada } from "@pinia/colada";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { RouterView } from "vue-router";

import { createGtmEvent } from "@solvari/argus";
import { initArgus } from "@solvari/argus/service";
import { initFontAwesome } from "@solvari/common-fe/integrations";
import { initCookiePopup, initPrimeVue } from "@solvari/components";
import { resolveClientId } from "@solvari/utils";

import router from "./router";

function addLogoutGtmEvent() {
  const url = new URL(window.location.href);
  const gtmLogoutUserId = url.searchParams.get("loggedOutUserId");
  if (gtmLogoutUserId) {
    void createGtmEvent("logout", { userId: Number(gtmLogoutUserId) });
    url.searchParams.delete("loggedOutUserId");
    window.history.replaceState(null, "", url.toString());
  }
}

function main() {
  initArgus(resolveClientId());
  initCookiePopup();
  initFontAwesome();
  addLogoutGtmEvent();

  const app = createApp(RouterView);

  app.use(createPinia());
  app.use(PiniaColada, {});
  app.use(router);
  initPrimeVue(app);

  const rootElement = document.querySelector("#auth-root")!;
  app.mount(rootElement);
}

main();
